import { createDownloadDocumentUrl, createDownloadLatestDocumentUrl } from './adminDocumentsAPI';
import { downloadFile } from '../../../ui-toolkit/utilities/downloadFile';

export const downloadDocument = async (documentId: string, versionId: string, fileName: string) =>
  downloadFile(createDownloadDocumentUrl(documentId, versionId), fileName);

export const downloadLatestDocument = async (standardDocId: string, fileName: string) =>
  downloadFile(createDownloadLatestDocumentUrl(standardDocId), fileName);
